import PropTypes from 'prop-types';

/**
 *
 * @param root0
 * @param root0.className
 * @param root0.dataCy
 * @param root0.children
 * @returns {JSX.Element} PageBody component
 */
function PageBody({ className, dataCy, children }) {
    return (
        <div className={`page-body ${className || ''} mx-4`} data-cy={dataCy}>
            {children}
        </div>
    );
}
PageBody.propTypes = {
    className: PropTypes.string,
    dataCy: PropTypes.string,
    children: PropTypes.any.isRequired
};

export default PageBody;